import { render } from "./selectCards.vue?vue&type=template&id=9182bf96&scoped=true"
import script from "./selectCards.vue?vue&type=script&lang=js"
export * from "./selectCards.vue?vue&type=script&lang=js"

import "./selectCards.vue?vue&type=style&index=0&id=9182bf96&scoped=true&lang=css"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9182bf96"]])

export default __exports__